<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="!cantGoBack"
    [title]="'Account Settings'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-card>
        <tidy-card-button (action)="goToEditContactInfo()" style="padding-top:0px">
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/smartphone.svg'"
              class="header-size" />
            <tidy-text
              [body]="'Contact Info'" />
          </tidy-row>
          <tidy-row>
            @if (clientInfo?.customer_account?.account_name) {
              <tidy-text
                [helper]="clientInfo?.customer_account?.account_name"
                [translate]="false" /><br>
            }
            <tidy-text
              [helper]="contactName"
              [translate]="false" /><br>
            <tidy-text
              [helper]="settings?.profile?.email"
              [translate]="false" /><br>
            <tidy-text
              [helper]="settings?.profile?.phone | telephone:'format'" />
            @if (settings?.profile?.phone === null || settings?.profile?.phone === '') {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/icon/alert-circle-red.svg'"
                  class="header-size" />
                <tidy-text
                  class="red"
                  [actionBody]="'Missing Phone number'" />
              </tidy-row>
            }
          </tidy-row>
        </tidy-card-button>
        @if (loginEmail && loginEmail !== settings?.profile?.email) {
          <tidy-row>
            <tidy-text
              [helper]="'Signed in as '" />
            <tidy-text
              [helper]="loginEmail"
              [translate]="false" />
          </tidy-row>
        }
        @if (userRole !== 'member') {
          <tidy-card-button (action)="goToAccountNotificationsPage()">
            <tidy-row class="vertical-align-center extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/alert.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Account Notifications'" />
            </tidy-row>
            @if (notificationSettings?.length == 0) {
              <tidy-row>
                <tidy-text
                  [helper]="'None'" />
              </tidy-row>
            }
            @for (setting of notificationSettings; track setting) {
              <tidy-row>
                <tidy-text
                  [body]="setting?.display_name + ': '" />
                @for (channel of setting.channels; track channel; let last = $last) {
                  <tidy-text
                    [helper]="channel?.name?.substring(0,37) + (channel?.name?.length > 37 ? '...' : '')"
                    [translate]="false" />
                  @if (!last) {
                    <tidy-text
                      [helper]="', '" />
                  }
                }
              </tidy-row>
            }
          </tidy-card-button>
        }
        <tidy-card-button (action)="goToEditAccountType()">
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/information-circle-yellow.svg'"
              class="header-size" />
            <tidy-text
              [body]="'Account Type'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [helper]="accountType" />
          </tidy-row>
        </tidy-card-button>
        @if (userRole !== 'member') {
          <tidy-card-button (action)="goToEditBackupTimes()">
            <tidy-row class="vertical-align-center extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/clock.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Default Backup Times'" />
            </tidy-row>
            <tidy-row>
              @if (!hasBackupTimes) {
                <tidy-text
                  [helper]="'None'" />
              }
              @for (time of scheduleAssurance?.customerAddress?.times; track time; let last = $last) {
                @if (time.start_time !== '00:00' && time.start_time !== null) {
                  <tidy-text
                    [helper]="(time.week_day | tweekday: true) + ' '" />
                  <tidy-text
                    [helper]="(time.start_time | parseDateTime: 'h:mma') + ' - ' + (time.end_time | parseDateTime: 'h:mma') + ' '" />
                  @if (last) {
                    <br>
                    }
                  }
                }
              </tidy-row>
            </tidy-card-button>
          }
          <tidy-card-button (action)="goToEditLanguage()">
            <tidy-row class="vertical-align-center extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/planet-earth.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Display Language'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="language" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="goToEditServiceNames()">
            <tidy-row class="vertical-align-center extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/list-circle-outline.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Edit Service Names for Me'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="'Customize how service names appear to you'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>


        <tidy-card>
          @if (clientInfo?.customer_account?.account_type !== 'rental') {
            <tidy-card-button [hideArrow]="true">
              <tidy-row class="extra-bottom-padding vertical-align-center">
                <tidy-image
                  [src]="'assets/img/salary.svg'"
                  class="header-size" />
                <tidy-text
                  [body]="'Referral Code'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="clientInfo?.customer_account?.referral_code" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'Friends who use this get $10 off their first job, then you get $10 off your next.'" />
              </tidy-row>
            </tidy-card-button>
          }
        </tidy-card>
      }
    </tidy-wrapper>
  </ng-template>

  <app-scroll-wrapper [templateContent]="content" />
